/** Keeps a free text currency input numeric: digits and up to two decimals. */
export const sanitizeAmount = (value) => {
  const [whole, ...decimals] = String(value || "")
    .replace(/[^\d.]/g, "")
    .split(".")
  return decimals.length ? `${whole}.${decimals.join("").slice(0, 2)}` : whole
}
